module.exports = __webpack_public_path__ + "static/img/game_left02.c65fb99b.png";